import React, { useState } from 'react';
import { Mail, Linkedin, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from './ui/button';

export const Team = () => {
  const [expandedProfile, setExpandedProfile] = useState(null);

  const toggleProfile = (index) => {
    setExpandedProfile(expandedProfile === index ? null : index);
  };

  const teamMembers = [
    {
      id: 1,
      name: "Emmanuel Gasana",
      position: "Managing Director",
      image: "https://customer-assets.emergentagent.com/job_evidentia-refresh/artifacts/zwx6xjk0_1701194441797.jpg",
      bio: "Emmanuel Gasana is Evidentia Africa's Founder with over 15 years of Monitoring and Evaluation experience. Emmanuel specializes in developing and implementing robust Monitoring and Evaluation (M&E) systems for projects and programs, adapting these programs/projects during implementation based on lessons learned, design, execution, and management of both performance and impact evaluations and is proficient in both qualitative and quantitative data collection and analysis techniques.",
      fullBio: "Emmanuel advised and led teams in delivering top-tier Monitoring and evaluations products for a wide array of clients, including notable organizations such as USAID Rwanda, USAID Implementing Partners, GIZ, the Belgian government, the government of Rwanda, Bank of Kigali and others. Emmanuel holds a Master of Science degree in Development Evaluation and Management from the University of Antwerp, Belgium. Prior to establishing Evidentia Africa, Emmanuel worked with the United States Agency for International Development (USAID/Rwanda) for 10 years as a Senior M&E specialist. Emmanuel is fluent in English and Kinyarwanda. He also has a fair understanding of the French language.",
      gradient: "gradient-primary"
    }
  ];

 

  return (
    <section id="team" className="section-padding bg-white relative overflow-hidden">
      
      {/* Background elements */}
      <div className="absolute inset-0 pattern-african opacity-15"></div>
      <div className="absolute top-1/4 right-1/4 w-96 h-96 gradient-warm rounded-full opacity-5 blur-3xl animate-bounce-subtle"></div>
      <div className="absolute bottom-1/3 left-1/4 w-80 h-80 gradient-nature rounded-full opacity-5 blur-3xl animate-bounce-subtle" style={{animationDelay: '2s'}}></div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        
        {/* Simplified team section header */}
        <div className="mb-12"></div>

 

        {/* Team Members */}
        <div className="space-y-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              <span className="text-gradient-primary">Our Team</span>
            </h3>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              Evidentia Africa Ltd maintains a roster of highly qualified researchers, data analysts, 
              monitoring and evaluation experts, subject matter specialists, as well as a roster of more than 
              100 trained Rwanda-based enumerators.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={member.id} className={`animate-slideInUp`} style={{animationDelay: `${index * 0.2}s`}}>
                <div className="card-modern group hover:scale-105 transition-all duration-500 overflow-hidden">
                  
                  {/* Profile Image */}
                  <div className="relative mb-6">
                    <div className="w-32 h-32 mx-auto rounded-2xl overflow-hidden shadow-xl group-hover:shadow-2xl transition-all duration-300">
                      <img 
                        src={member.image}
                        alt={member.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className={`absolute -inset-4 ${member.gradient} rounded-2xl opacity-0 group-hover:opacity-10 blur-xl transition-all duration-300`}></div>
                  </div>
                  
                  {/* Profile Info */}
                  <div className="text-center">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
                    <p className="text-gradient-primary font-bold mb-4 text-sm uppercase tracking-wide">{member.position}</p>
                    
                    {/* Bio Display */}
                    <div className="mb-6">
                      {expandedProfile === index ? (
                        <div className="animate-fadeInUp">
                          <p className="text-gray-600 leading-relaxed text-sm mb-4">
                            {member.bio}
                          </p>
                          <p className="text-gray-600 leading-relaxed text-sm">
                            {member.fullBio}
                          </p>
                        </div>
                      ) : (
                        <p className="text-gray-600 leading-relaxed text-sm overflow-hidden" style={{
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical'
                        }}>
                          {member.bio}
                        </p>
                      )}
                    </div>
                    
                    {/* Actions */}
                    <div className="flex flex-col space-y-4">
                      <Button 
                        onClick={() => toggleProfile(index)}
                        className="btn-outline group w-full"
                      >
                        {expandedProfile === index ? (
                          <>
                            Show Less <ChevronUp className="w-4 h-4 ml-2 group-hover:-translate-y-1 transition-transform duration-300" />
                          </>
                        ) : (
                          <>
                            Read More <ChevronDown className="w-4 h-4 ml-2 group-hover:translate-y-1 transition-transform duration-300" />
                          </>
                        )}
                      </Button>
                      
                      <div className="flex justify-center space-x-3">
                        <a 
                          href="https://www.linkedin.com/in/emmanuel-gasana-9b7952269/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="w-10 h-10 bg-gradient-to-br from-gray-50 to-white border border-gray-200 hover:border-blue-300 rounded-xl flex items-center justify-center text-gray-600 hover:text-blue-600 transition-all duration-300 shadow-sm hover:shadow-lg"
                        >
                          <Linkedin className="w-5 h-5" />
                        </a>
                        <a 
                          href="mailto:emma@evidentia.africa"
                          className="w-10 h-10 bg-gradient-to-br from-gray-50 to-white border border-gray-200 hover:border-teal-300 rounded-xl flex items-center justify-center text-gray-600 hover:text-teal-600 transition-all duration-300 shadow-sm hover:shadow-lg"
                        >
                          <Mail className="w-5 h-5" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

 
      </div>
    </section>
  );
};